import React from "react";
// import { useHistory} from 'react-router-dom';
import Cookies from "js-cookie";
import { LogoutOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Logout.css";

const Logout = () => {
  // const history = useHistory();
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const firstName = Cookies.get("first_name");
  const lastName = Cookies.get("last_name");
  const onClickLogout = () => {
    Cookies.remove("jwt_token");
    Cookies.remove("UserLogin");
    Cookies.remove("first_name");
    Cookies.remove("last_name");
    Cookies.remove("Role");
    Cookies.remove("Date");
  };
  return (
    <div>
      <Link
        to={{ pathname: "/", state: { logoutMsg: "yes" } }}
        style={{ textDecoration: "none" }}
        onClick={onClickLogout}
      >
        <img src="./Images/Group 849.png" alt="Logout" style={{fontSize: 23,marginRight:8,marginTop:12}}/>
      </Link>
    </div>
  );
};
export default Logout;
